<template>
	<LayoutDefault>
		<div
				class="container dark"
				id="frequently_asked_questions"
		>
			<div class="content">
				<section class="faqs">
					<h3 class="title">Preguntas Frequentes</h3>

					<template v-if="loadingFaqs">
						<Spinner></Spinner>
					</template>
					<template
							v-if="!loadingFaqs"
					>
							<FrequentlyAskedQuestionBox
									v-for="faq in faqs"
									:faq="faq"
									:key="faq.id"
							></FrequentlyAskedQuestionBox>

					</template>
				</section>
			</div>
		</div>
	</LayoutDefault>
</template>

<script>
	import FrequentlyAskedQuestionBox from '../components/FrequentlyAskedQuestionBox';
	import Spinner from '../components/Spinner';


	import resources from '../resources';

	import EventBus from '../eventbus';
	import LayoutDefault from "../layouts/LayoutDefault";

    export default {
		components: {
			LayoutDefault,
			FrequentlyAskedQuestionBox,
			Spinner
		},
		methods: {
			loadFaqs(){
				this.loadingFaqs = true;
				this.errorFaqs 	 = false;

				resources.frequentlyAskedQuestions.index({per_page: 999, priority: 1, page: 1})
					.then((response) => {
						this.loadingFaqs = false;
						this.faqs = response.data.data;
					})
					.catch(() => {
						this.loadingFaqs = false;
						this.errorFaqs 	 = true;
					});
			},
		},
		data(){
			return {
				loadingFaqs: true,
				errorFaqs: false,
				faqs: null
			}
		},
		mounted(){
			this.loadFaqs();

			EventBus.$on('languageChanged', () => {
				this.loadFaqs();
			});
		},
	}
</script>

<style scoped lang="scss">
  #frequently_asked_questions{
      min-height: 500px;
      padding: 9px;
  }
</style>